(function () {
  if (window.__ntCarryBagAddon) return;
  window.__ntCarryBagAddon = true;

  var overlay = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  /* ---------------- Photo popup ---------------- */

  function buildOverlay() {
    overlay = document.createElement('div');
    overlay.className = 'nt-addon-modal';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="nt-addon-modal__dialog" role="dialog" aria-modal="true" aria-label="Carry bag">' +
      '<button type="button" class="nt-addon-modal__close" data-nt-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
      '<path d="M5 5 19 19M19 5 5 19" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>' +
      '</svg></button>' +
      '<img class="nt-addon-modal__img" src="" alt="">' +
      '<p class="nt-addon-modal__cap"></p>' +
      '</div>';
    // Click the dim area or the cross to close.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || (e.target.closest && e.target.closest('[data-nt-close]'))) closeModal();
    });
    document.body.appendChild(overlay);
  }

  function openModal(src, alt, caption) {
    if (!overlay) buildOverlay();
    var img = overlay.querySelector('.nt-addon-modal__img');
    img.src = src;
    img.alt = alt || '';
    overlay.querySelector('.nt-addon-modal__cap').textContent = caption || '';
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    overlay.querySelector('.nt-addon-modal__close').focus();
  }

  function closeModal() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.nt-addon__thumb');
    if (!thumb) return;
    e.preventDefault();
    openModal(thumb.dataset.ntFull, thumb.dataset.ntAlt, thumb.dataset.ntCaption);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeModal();
  });

  /* ---------------- Selected state ---------------- */

  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('.nt-addon__cb');
    if (!cb) return;
    var box = cb.closest('.nt-addon');
    if (box) box.classList.toggle('nt-addon--on', cb.checked);
  });

  /* ---------------- Add to cart ----------------
     Capture phase runs before Dawn's own submit handler on the form, so the
     bag lands in the cart first and the drawer renders with both lines. */

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      if (form.dataset.ntAddonDone === '1') {
        delete form.dataset.ntAddonDone;
        return;
      }

      var cb = form.querySelector('.nt-addon__cb:checked');
      if (!cb) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      addToCart([{ id: Number(cb.value), quantity: 1 }])
        .catch(function () {})
        .finally(function () {
          cb.checked = false;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
          form.dataset.ntAddonDone = '1';
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        });
    },
    true
  );

  /* ---------------- Buy it now ----------------
     The dynamic checkout button skips the cart entirely, so with the bag ticked
     it would silently drop it. Intercept it, put both lines in the cart, and
     send the buyer straight to checkout — same one-tap result, bag included. */

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.shopify-payment-button__button');
      if (!btn) return;

      var form = btn.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      var cb = form.querySelector('.nt-addon__cb:checked');
      if (!cb) return;

      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.classList.add('nt-addon-busy');

      addToCart([
        { id: Number(idInput.value), quantity: qty },
        { id: Number(cb.value), quantity: 1 }
      ])
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = root() + 'checkout';
        })
        .catch(function () {
          btn.classList.remove('nt-addon-busy');
        });
    },
    true
  );
})();
